// src/App.jsx

import Footer from "./components/menu/footer";
import Carrusel from "./components/landing/carrusel";
import Navbar from "./components/landing/navbar";
import Hero from "./components/landing/hero";
import Service from "./components/landing/service";
import Benefits from "./components/landing/benefits";
import SocialsMedia from "./components/landing/socialsmedia";
import Contact from "./components/landing/contact";
import Map from "./components/landing/map";



const Landing = () => {


    return (
        <div className="bg-[#1e293b] text-white font-sans">
            <Navbar />
            <Hero />
            <Service />
            <Carrusel />
            <Benefits />
            <Map />
            <Contact />
            <SocialsMedia />
            <Footer />
        </div>
    );
}

export default Landing;
